import Checkbox from '@anm/components/form/Checkbox';
import { useCallback, useEffect, useState, FC } from 'react';

import { ControlLabel, LabelText, TooltipWrapper, Wrapper } from './Wrapper';

export { Wrapper as CheckboxWrapper };

export type CustomizationFormCheckboxProps = {
  id: string;
  controlValue: boolean;
  onChange: (value: CheckboxValue) => void;
  label?: string;
  disabled?: boolean;
  isDefaultChecked?: boolean;
  renderTooltip?: () => JSX.Element;
};

export type CheckboxValue = {
  id: string;
  value: boolean;
};

const CustomizationFormCheckbox: FC<CustomizationFormCheckboxProps> = ({
  id,
  label,
  onChange,
  disabled = false,
  isDefaultChecked,
  renderTooltip
}) => {
  const [checked, setIsChecked] = useState(!!isDefaultChecked);
  const [wasChanged, setWasChanged] = useState(false);

  useEffect(() => {
    if (!wasChanged) {
      setWasChanged(true);
      return;
    }

    onChange({ id, value: checked });
  }, [checked]);

  const handleChange = useCallback(() => {
    setIsChecked(checked => !checked);
  }, [checked]);

  return (
    <Wrapper {...{ disabled, id }}>
      <TooltipWrapper variant="white" renderContent={renderTooltip}>
        <ControlLabel>
          <Checkbox checked={checked} onChange={handleChange} />
          {label && <LabelText>{label}</LabelText>}
        </ControlLabel>
      </TooltipWrapper>
    </Wrapper>
  );
};

export default CustomizationFormCheckbox;
